import React from 'react';

import {Card} from '../../../components/Card/Card';

import icon_call from './icon-call.svg'
import icon_police from './icon-police.svg'
import icon_rouble from './icon-rouble.svg'

import cls from './Structure.module.scss'

export const Structure = () => (
    <div className={cls.block}>
        <h2>Что входит в&nbsp;услугу</h2>
        <div className={cls.cards}>
            <Card bottom={
                <div className={cls.content}>
                    <h2>Возмещение расходов</h2>
                    <div>Возмещение транспортных, юридических и&nbsp;расходов на&nbsp;оплату государственной пошлины, возникшие в&nbsp;результате оспаривания кредита, оформленного мошенническим путем
                    </div>
                </div>
            }><img src={icon_rouble} alt={'Icon Rouble'}/></Card>
            <Card color={'pink'} bottom={
                <div className={cls.content}>
                    <h2>Консультации</h2>
                    <div>Юридические консультации при подготовке документов в&nbsp;банк, в&nbsp;случае оспаривания кредита, оформленного мошенническим путем
                    </div>
                </div>
            }><img src={icon_call} alt={'Icon Call'}/></Card>
            <Card color={'black'} bottom={
                <div className={cls.content}>
                    <h2>Сопровождение</h2>
                    <div>Онлайн сопровождение в&nbsp;процессе взаимодействия с&nbsp;полицией по&nbsp;вопросам кражи денежных средств с&nbsp;карты или незаконного оформления кредита третьими лицами
                    </div>
                </div>
            }><img src={icon_police} alt={'Icon Police'}/></Card>
        </div>
    </div>
)